import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import IRole from '../../../_interfaces/IRole';
import IWidget from '../../../_interfaces/IWidget';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { RolesService } from '../../../_services/roles/roles.service';
import { WidgetsService } from '../../../_services/widgets/widgets.service';
import { BaseComponent } from '../../../components/base/base.component';
import { SessionService } from '../../../_services/session/session.service';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-form-role-widgets',
  templateUrl: './form-role-widgets.component.html',
  styleUrls: ['./form-role-widgets.component.scss'],
  imports: [TableModule, TranslatePipe, InputSwitchModule, FormsModule],
})
export class FormRoleWidgetsComponent extends BaseComponent implements OnInit {
  @Input('payload')
  public role: IRole;
  public widgets: IWidget[] = [];
  public roleHasWidget: any = {};

  constructor(
    public messageService: MessageService,
    public rolesService: RolesService,
    public session: SessionService,
    public widgetService: WidgetsService,
    public translate: TranslateService,
    private errorsService: ErrorsService
  ) {
    super(session);
  }

  updateRoleHasWidget() {
    this.role.widgets.forEach((widget: IWidget) => {
      this.roleHasWidget[widget.code] = true;
    });
  }

  loadRole() {
    this.rolesService
      .get(this.customers_id, this.role.id)
      .subscribe((role: IRole) => {
        this.role = role;
        this.updateRoleHasWidget();
      });
  }

  updateWidget(event, widget: IWidget) {
    const value = event.checked;
    const status = value ? 'ACTIVATED' : 'DEACTIVATED';
    this.rolesService
      .updateWidget(this.customers_id, this.role.id, widget.id, value)
      .subscribe(
        () => {
          this.messageService.add({
            severity: 'success',
            summary: this.translate.instant(
              `MESSAGES.WIDGETS.${status}.SUMMARY`
            ),
            detail: this.translate.instant(
              `MESSAGES.WIDGETS.${status}.DETAIL`,
              {
                widget: widget.name,
                role: this.role.name,
              }
            ),
          });
          this.loadRole();
        },
        (error) => {
          const code = this.errorsService.getMessageFromWidgetError(error);
          this.messageService.add({
            summary: this.translate.instant('MESSAGES.WIDGETS.ERROR.SUMMARY'),
            detail: this.translate.instant(`MESSAGES.WIDGETS.ERROR.${code}`),
            severity: 'error',
          });
        }
      );
  }

  loadWidgets() {
    this.widgetService.getAll(this.customers_id).subscribe((widgets) => {
      this.widgets = widgets.map((widget) => {
        widget.name = this.translate.instant(`WIDGETS.${widget.code}.TITLE`);
        return widget;
      });
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.loadWidgets();
    this.loadRole();
  }
}
